import { TranslatableString } from '/types';

import useTranslate from './translations';

const useMonthNames = (): TranslatableString[] => {
  const t = useTranslate();
  return [
    t('January'),
    t('February'),
    t('March'),
    t('April'),
    t('May'),
    t('June'),
    t('July'),
    t('August'),
    t('September'),
    t('October'),
    t('November'),
    t('December'),
  ];
};

export default useMonthNames;
